export default class Enum {
  constructor(data) {
    this.enum = data;
    this.keys = Object.keys(data);
  }

  getValue(key) {
    return this.enum[key];
  }

  toList() {
    return this.keys.map((key) => ({
      text: this.getValue(key),
      value: key,
    }));
  }
}
